import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Alert, Button, Stack } from "@mui/material";
import { type FacilityNote } from "@src/appV2/Facilities/types";
import { WorkplaceNoteIdentifier } from "@src/appV2/redesign/Workplace/constants";
import {
  type WorkplaceQuizResultLogSchema,
  WorkplaceQuizResultStatus,
} from "@src/appV2/WorkplaceQuiz/types";

export interface WorkplaceRulesProps {
  facilityNotes: Array<
    Pick<
      FacilityNote,
      "isVisibleToWorker" | "categoryTextVisibleToWorker" | "noteId" | "note" | "identifier"
    >
  >;
  latestQuizResultLog?: WorkplaceQuizResultLogSchema;
  onStartQuiz: () => void;
}

export function WorkplaceRules(props: WorkplaceRulesProps) {
  const { facilityNotes, latestQuizResultLog, onStartQuiz: onClickStartQuiz } = props;
  return (
    <>
      <Stack spacing={2} flexGrow={1} pt={3}>
        <Alert variant="filled" severity="info">
          <Text color="inherit">
            Review the following facility information before continuing to take the quiz.
          </Text>
        </Alert>
        {facilityNotes
          .filter(
            ({ note, isVisibleToWorker, identifier }) =>
              isVisibleToWorker &&
              identifier !== WorkplaceNoteIdentifier.MANDATORY_BREAK_POLICY &&
              identifier !== WorkplaceNoteIdentifier.REST_BREAK_POLICY &&
              isDefined(note) &&
              note.trim().length > 0
          )
          .map(({ noteId, categoryTextVisibleToWorker, note }) => (
            <Text key={noteId}>
              <Text sx={{ display: "inline", fontWeight: "bold" }}>
                {categoryTextVisibleToWorker}:{" "}
              </Text>{" "}
              {note}
            </Text>
          ))}
      </Stack>
      <Button
        fullWidth
        sx={{ marginTop: 3, marginBottom: 2 }}
        variant="contained"
        onClick={onClickStartQuiz}
      >
        {isDefined(latestQuizResultLog) &&
        latestQuizResultLog.attributes.newStatus === WorkplaceQuizResultStatus.PASSED
          ? `Passed: ${(latestQuizResultLog.attributes.stats.scorePercentage * 100).toFixed(
              0
            )}% Correct`
          : "Start Quiz"}
      </Button>
    </>
  );
}
